import script from "./UserPlanBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPlanBadge.vue?vue&type=script&setup=true&lang=js"

import "./UserPlanBadge.vue?vue&type=style&index=0&id=083e58ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083e58ca"]])

export default __exports__